import { Component, OnInit } from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-tandarts-header',
  templateUrl: '../../../../../assets/html/webshoptandarts.html',
  styleUrls: ['./header.component.css']
})
export class TandartsHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    var t = $('[data-parallax="scroll"]').data('imageSrc');
    $('[data-parallax="scroll"]').parallax({imageSrc: t});
  }

}
